<div class="carousel-row group">
  <div class="carousel-viewport">
    <div class="keen-slider" #sliderRef>
      <ng-content></ng-content>
    </div>
  </div>

  <button
    *ngIf="showArrows"
    type="button"
    (click)="prev()"
    class="arrow-hover-scale-wrapper carousel-arrow carousel-arrow--left"
    aria-label="Previous"
  >
    <img
      class="arrow-hover-scale"
      [src]="assetUrl + 'icons/arrow-left-20.svg'"
      alt="Previous"
    />
  </button>

  <button
    *ngIf="showArrows"
    type="button"
    (click)="next()"
    class="arrow-hover-scale-wrapper carousel-arrow carousel-arrow--right"
    aria-label="Next"
  >
    <img
      class="arrow-hover-scale"
      [src]="assetUrl + 'icons/arrow-right-20.svg'"
      alt="Next"
    />
  </button>
</div>
